import { defaultAxios, IParams } from './base';

export interface IFetchUrlFromCode extends IParams {
  srcCd?: string;
}
export const fetchUrlFromSrcCd = (params: IFetchUrlFromCode) => {
  return defaultAxios().post(`/base/getUrlFromSrcCd`, params);
};
